import { http_client } from "@/plugins/http_client";

const url = "/api/v1/funcion";
const solicitudUrl = url + "/solicitudes-funciones";
const catalogoUrl = url + "/catalogo";
const removerFuncionesUrl = url + "/remover-funciones";
const urlPresupuesto = "/api/v1/presupuesto";
const catalogoCifradoBeneficioUrl = "/api/v1/beneficio/catalogo/cifrado";

const getListadoSolicitudes = async (id_tab, params = {}) =>
  await http_client(`${solicitudUrl}/${id_tab}`, params, "get");

const getEstadosSolicitud = async (idTab) =>
  await http_client(`${url}/catalogo/estados/${idTab}`, {}, "get");

const getPerfilesTabsSolicitud = async () =>
  await http_client(`${solicitudUrl}/switch-tabs`, {}, "get");

const getDetalleSolicitud = async (id, params = {}) =>
  await http_client(`${solicitudUrl}/detalle/${id}`, params, "get");

const getDetalleEmpleadoPorDocumento = async (numeroDocumento) =>
  await http_client(`${solicitudUrl}/detalle-empleado/${numeroDocumento}`, {}, "get");

const getDetalleBannerEmpleado = async (idEmpleadoPuesto) =>
  await http_client(`${solicitudUrl}/detalle-banner-empleado`, { id_empleado_puesto: idEmpleadoPuesto }, "get");

const postCrearSolicitud = async (params) =>
  await http_client(`${url}/crear`, params, "post");

const getDescargarDocumento = async (id) =>
  await http_client(`${url}/descargar/${id}`, {}, "get", {
    responseType: "blob",
  });

const getVerDocumentoAcuerdo = async (id_solicitud, firmado) =>
  await http_client(`${url}/acuerdos/ver-documento-acuerdo`, { id_solicitud, firmado }, "get");

const getExpedientesEmpleados = async (params = {}) =>
  await http_client(`${url}/expedientes-empleados`, params, "get");

const getCatalogoTipoDocumento = async () =>
  await http_client(`${catalogoUrl}/tipo-documento`, {}, "get");

const getCatalogoFuncionesPorEmpleadoPuesto = async (idEmpleadoPuesto) =>
  await http_client(`${catalogoUrl}/funcion/${idEmpleadoPuesto}`, {}, "get");

const getCatalogoTiposCompensacion = async () =>
  await http_client(`${catalogoUrl}/tipo-compensacion`, {}, "get");

const getDetalleSolicitudRemoverFunciones = async (idSolicitud, params = {}) =>
  await http_client(`${removerFuncionesUrl}/detalle/${idSolicitud}`, params, "get");

const getDetalleBannerEmpleadoSolicitudFunciones = async (idEmpleadoPuesto) =>
  await http_client(`${solicitudUrl}/detalle-banner-empleado`, { id_empleado_puesto: idEmpleadoPuesto }, "get");

const getBannerSeguimientoRemoverFunciones = async (idSolicitud) =>
  await http_client(`${removerFuncionesUrl}/banner-seguimiento/${idSolicitud}`, {}, "get");

const postMovimientoSolicitudRemoverFunciones = async (idSolicitud, params) =>
  await http_client(`${removerFuncionesUrl}/movimiento-solicitud/${idSolicitud}`, params, "post");

const postEnviarSolicitudFunciones = async (params) =>
  await http_client(`${solicitudUrl}/enviar`, params, "post");

const putActualizarSolicitudFunciones = async (idSolicitud, params) =>
  await http_client(`${solicitudUrl}/${idSolicitud}`, params, "put");

const postActualizarEstadoSolicitud = async (idSolicitud, params) =>
  await http_client(`${solicitudUrl}/movimiento-solicitud/${idSolicitud}`, params, "post");

const getBannerSeguimiento = async (idSolicitud) =>
  await http_client(`${solicitudUrl}/banner-seguimiento/${idSolicitud}`, {}, "get");

const getBitacora = async (idSolicitud, params = {}) =>
  await http_client(`${solicitudUrl}/bitacora/${idSolicitud}`, params, "get");

const getCatalogoTipoAsignacion = async () =>
  await http_client(`${catalogoUrl}/tipo-asignacion`, {}, "get");

const getCatalogoCifradosPresupuestarios = async () =>
  await http_client(`${catalogoUrl}/cifrados`, {}, "get");

const getCatalogoRubrosPresupuestarios = async () =>
  await http_client(`${catalogoUrl}/rubros`, {}, "get");

const getCatalogoCifradosBeneficio = async () =>
  await http_client(catalogoCifradoBeneficioUrl, {}, "get");

const getRubrosContratacionPorCifrado = async (idCifrado) =>
  await http_client(
    `${urlPresupuesto}/anual/establecimientos/cifrados/especificos-gastos/contratacion/${idCifrado}`,
    {},
    "get"
  );

const getCuentasContratacionPorRubro = async (idRubro) =>
  await http_client(
    `${urlPresupuesto}/anual/establecimientos/cifrados/especificos-gastos/contratacion/padre/${idRubro}`,
    {},
    "get"
  );

const postAsignarCifradoPresupuestario = async (idSolicitud, payload) =>
  await http_client(`${solicitudUrl}/asignar-cifrado/${idSolicitud}`, payload, "post");

const postGuardarComprobanteSolicitud = async (idSolicitud, documento) => {
  const formData = new FormData();
  formData.append('documento', documento);

  return http_client(
    `${solicitudUrl}/comprobante/${idSolicitud}`,
    formData,
    "post",
    { "Content-Type": "multipart/form-data" }
  );
};

const postGenerarDocumentoAcuerdo = async (idSolicitud) =>
  await http_client(`${url}/acuerdos/generar-documento-acuerdo`, { id_solicitud: idSolicitud }, "post");

const postFirmarDocumentoAcuerdo = async (idSolicitud) =>
  await http_client(`${url}/acuerdos/firmar-documento-acuerdo`, { id_solicitud: idSolicitud }, "post");

const getBusquedaSolicitud = async (idEmpleadoPuesto, params = {}) =>
  await http_client(`${solicitudUrl}/busqueda-solicitud/${idEmpleadoPuesto}`, params, "get");

const getPlazasEmpleado = async (numeroDocumento) =>
  await http_client(`${solicitudUrl}/plazas-empleado/${numeroDocumento}`, {}, "get");

const getMontoMaximoPermitido = async (idEmpleadoPuesto) =>
  await http_client(`${solicitudUrl}/plaza/monto-maximo/${idEmpleadoPuesto}`, {}, "get");


export default {
  getListadoSolicitudes,
  getEstadosSolicitud,
  getPerfilesTabsSolicitud,
  getDetalleSolicitud,
  getDetalleEmpleadoPorDocumento,
  getDetalleBannerEmpleado,
  postCrearSolicitud,
  getDescargarDocumento,
  getVerDocumentoAcuerdo,
  getExpedientesEmpleados,
  getCatalogoFuncionesPorEmpleadoPuesto,
  getCatalogoTiposCompensacion,
  getDetalleSolicitudRemoverFunciones,
  getDetalleBannerEmpleadoSolicitudFunciones,
  getBannerSeguimientoRemoverFunciones,
  postMovimientoSolicitudRemoverFunciones,
  postEnviarSolicitudFunciones,
  putActualizarSolicitudFunciones,
  postActualizarEstadoSolicitud,
  getBannerSeguimiento,
  getBitacora,
  getCatalogoTipoDocumento,
  getExpedientesEmpleados,
  getCatalogoTipoAsignacion,
  getCatalogoCifradosPresupuestarios,
  getCatalogoRubrosPresupuestarios,
  getCatalogoCifradosBeneficio,
  getRubrosContratacionPorCifrado,
  getCuentasContratacionPorRubro,
  postAsignarCifradoPresupuestario,
  postGuardarComprobanteSolicitud,
  postGenerarDocumentoAcuerdo,
  postFirmarDocumentoAcuerdo,
  getBusquedaSolicitud,
  getPlazasEmpleado,
  getMontoMaximoPermitido,
};
